module.exports = __webpack_public_path__ + "static/PHMBedroomTerrace-998a8acf6ed45cc2963bd375ddaab75e.jpg";